// extracted by mini-css-extract-plugin
module.exports = {"titleHeader":"title_titleHeader__3KwuX","text":"title_text__3tVrr","title":"title_title__3uFug","side":"title_side__2-FpH"};